export const FORECAST_METHOD_CONFIG = {
  SES: {
    label: "SES",
    color: "success" as const,
    tooltip:
      "Suavizamiento exponencial simple. Se usa para demanda suave y relativamente estable.",
  },
  HW: {
    label: "HW",
    color: "info" as const,
    tooltip:
      "Holt-Winters. Se usa para demanda suave con suficiente historial y posible estacionalidad.",
  },
  HOLT_WINTERS: {
    label: "HW",
    color: "info" as const,
    tooltip:
      "Holt-Winters. Se usa para demanda suave con suficiente historial y posible estacionalidad.",
  },
  TSB: {
    label: "TSB",
    color: "warning" as const,
    tooltip:
      "Teunter-Syntetos-Babai. Se usa para demanda intermitente, especialmente cuando puede haber obsolescencia.",
  },
  CRO: {
    label: "CRO",
    color: "secondary" as const,
    tooltip: "Croston. Se usa para demanda intermitente.",
  },
  CROSTON: {
    label: "CRO",
    color: "secondary" as const,
    tooltip: "Croston. Se usa para demanda intermitente.",
  },
  SBA: {
    label: "SBA",
    color: "error" as const,
    tooltip:
      "Syntetos-Boylan Approximation. Se usa para demanda erratica o lumpy.",
  },
  HIST: {
    label: "HIST",
    color: "success" as const,
    tooltip:
      "Historico. Metodo legado basado en datos reales del mismo mes del anio pasado.",
  },
  PROM: {
    label: "PROM",
    color: "info" as const,
    tooltip:
      "Promedio. Metodo legado basado en promedio mensual con tendencia.",
  },
  MIX: {
    label: "MIX",
    color: "warning" as const,
    tooltip: "Mixto. Metodo legado que combinaba historico y promedio.",
  },
  "N/D": {
    label: "N/D",
    color: "default" as const,
    tooltip:
      "Sin forecast utilizable. No hay forecast almacenado, no hay datos suficientes o la demanda fue clasificada como no_demand.",
  },
};

export function getForecastMethodEntry(method?: string | null) {
  const normalized = String(method ?? "N/D")
    .trim()
    .toUpperCase();
  return (
    FORECAST_METHOD_CONFIG[normalized as keyof typeof FORECAST_METHOD_CONFIG] ??
    FORECAST_METHOD_CONFIG["N/D"]
  );
}
